import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { ServiceID } from "src/app/property-management-dashboard/enum/service-id.enum";

import { environment } from "src/environments/environment";
import { SecurityConstants } from "../constants/security.constants";

@Injectable({
  providedIn: "root",
})
export class SecurityService {
  private authorizeEndpoint = SecurityConstants.authorizeEndpoint;
  private baseUrl = environment.apiUrl;
  private tokenKey = SecurityConstants.tokenKey;
  private redirectUri = environment.redirectUri;
  private serviceIdKey = SecurityConstants.serviceKey;
  private buidKey = SecurityConstants.buidKey;
  private roleKey = SecurityConstants.roleKey;
  private serviceMapKey = SecurityConstants.serviceMapKey;
  private allBuids = SecurityConstants.allBuids;
  private userImgPaths = ["../../assets/user.gif", "../../assets/batman.gif", "../../assets/xmen.gif"];
  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

  login() {
    window.open(this.baseUrl + this.authorizeEndpoint, "_self");
  }

  loginCheck(): boolean {
    const token = this.getToken();
    return token != null && token != "null";
  }

  getUserName(): any {
    return this.http.get(this.baseUrl + "/user/username", {
      responseType: "text",
    });
  }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public updateToken(token: string): void {
    window.sessionStorage.removeItem(this.tokenKey);
    window.sessionStorage.setItem(this.tokenKey, token);
    let userImagePath: string = this.userImgPaths[Math.floor(Math.random() * this.userImgPaths.length)];
    window.sessionStorage.setItem("userImage", userImagePath);
  }
  public getUserImg(): string {
    return sessionStorage.getItem("userImage") as string;
  }

  updateUserInfo(res: any) {
    this.encodeServiceMap(res);
  }

  public getToken(): any {
    return sessionStorage.getItem(this.tokenKey);
  }

  public getRoles() {
    let role = sessionStorage.getItem(this.roleKey);
    if (role) {
      return [role];
    }
    return [];
  }
  public getRole() {
    let role = sessionStorage.getItem(this.roleKey);
    return role;
  }

  public setServiceId(serviceId: string) {
    window.sessionStorage.setItem(this.serviceIdKey, serviceId);
  }
  public setRole(role: string) {
    window.sessionStorage.setItem(this.roleKey, role);
  }

  public setProfileImage(image: string) {
    window.sessionStorage.setItem("userImage", image);
  }

  public setAllBuids(isAllBuids: boolean){
    window.sessionStorage.setItem(this.allBuids, String(isAllBuids));
  }

  public isAllBuidsEnabled(){
    let isAllBuidsEnabled = sessionStorage.getItem(this.allBuids);
    if (isAllBuidsEnabled === "true") {
      return true;
    }
    return false;
  }

  public getServiceId(): string {
    var serviceId = window.sessionStorage.getItem(this.serviceIdKey);
    if (serviceId == null) {
      return "";
    }
    return serviceId;
  }

  private encodeServiceMap(serviceMap: { [key: string]: any }) {
    console.log(serviceMap);

    const jsonString = JSON.stringify(serviceMap);
    const encodedString = btoa(jsonString);
    window.sessionStorage.setItem(this.serviceMapKey, encodedString);
    const key = Object.keys(serviceMap)[0];
    this.setServiceId(key);
    this.setRole(serviceMap[key]);
  }

  public getServiceMap(): { [key: string]: any } {
    const encodedString = window.sessionStorage.getItem(this.serviceMapKey);
    if (encodedString == null) {
      return {};
    }
    const decodedString = atob(encodedString);
    const decodedJSON = JSON.parse(decodedString);
    return decodedJSON;
  }
}
